import React, { useCallback, useContext } from 'react'
import { useNavigate, Routes, Route } from 'react-router-dom'
import { AuthContext } from '@/layout/Auth'
import { PlainCard } from '../components'
import CreateToken from './createForm'
import APITokenList from './list'
import ErrorBoundary from '@/layout/Error'
import { ensureSecurityGate } from '@/utils/securityGate'

const APIToken: React.FC<unknown> = () => {
  const navigate = useNavigate()
  const { authInfo } = useContext(AuthContext)
  const orgInfo = authInfo?.orgInfo

  const gotoList = useCallback(() => {
    navigate('/console/organization/api')
  }, [navigate])

  const gotoCreate = useCallback(() => {
    ;(async () => {
      if (!(await ensureSecurityGate('api_token'))) return
      navigate('/console/organization/api/createToken')
    })()
  }, [navigate])

  return (
    <PlainCard>
      <Routes>
        <Route
          path='/'
          errorElement={<ErrorBoundary />}
          // @ts-ignore
          element={<APITokenList orgInfo={orgInfo} onAdd={gotoCreate} />}
        />
        <Route
          path='createToken'
          errorElement={<ErrorBoundary />}
          element={<CreateToken onCancel={gotoList} />}
        />
      </Routes>
    </PlainCard>
  )
}

export default APIToken
